import { forwardRef, type Ref, type SVGProps } from "react";
const IconStar100PercentSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M28.28 11.46 21 10.12l-3.52-6.9c-.83-1.63-2.19-1.63-3 0L11 10.12l-7.28 1.34c-1.8.34-2.26 1.71-1 3.06l5.16 5.6-1 7.78c-.24 1.8.9 2.6 2.53 1.77L16 26.3l6.65 3.37c1.63.83 2.77 0 2.53-1.77l-1-7.78 5.16-5.6c1.2-1.35.74-2.72-1.06-3.06"
    />
  </svg>
);
const ForwardRef = forwardRef(IconStar100PercentSVG);
ForwardRef.displayName = "IconStar100Percent";
export { ForwardRef as IconStar100Percent };
